/* v11: navigation follows only its own product information section. No cart or personalizer changes. */
(() => {
 'use strict';
 if (window.mbmMobileStudioV11) return;
 window.mbmMobileStudioV11 = true;
 const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
 const phone = window.matchMedia('(max-width:749px)');
 const navigators = new Map();
 const titles = new Map();
 const collectionDetails = new Set();
 let pending = false;
 function headerOffset() {
  let bottom = 0;
  document.querySelectorAll('sticky-header,.shopify-section-header-sticky,.mbm-site-header').forEach(el => {
   const rect = el.getBoundingClientRect();
   let parent = el, attached = false;
   for (let n = 0; parent && n < 3; n++, parent = parent.parentElement) {
    if (['sticky','fixed'].includes(getComputedStyle(parent).position)) attached = true;
   }
   if (attached && rect.top < 48 && rect.bottom > 0) bottom = Math.max(bottom,rect.bottom);
  });
  return Math.round(bottom) + 8;
 }
 function unpin(rec) {
  rec.nav.classList.remove('is-pinned');
  rec.anchor.style.height = '0px';
  ['left','width','top'].forEach(key => rec.nav.style.removeProperty(key));
 }
 function layout() {
  pending = false;
  const top = headerOffset();
  navigators.forEach((rec,info) => {
   if (!info.isConnected || !rec.nav.isConnected) {
    rec.observer?.disconnect(); navigators.delete(info); return;
   }
   const rect = info.getBoundingClientRect();
   const anchor = rec.anchor.getBoundingClientRect();
   const height = Math.ceil(rec.nav.getBoundingClientRect().height);
   const pin = rect.width > 0 && anchor.top <= top && rect.bottom > top + height + 16;
   if (!pin) {unpin(rec);return;}
   rec.anchor.style.height = height + 'px';
   rec.nav.classList.add('is-pinned');
   rec.nav.style.left = rect.left + 'px';
   rec.nav.style.width = rect.width + 'px';
   rec.nav.style.top = top + 'px';
  });
 }
 function schedule() {if (!pending) {pending = true;requestAnimationFrame(layout);}}
 function positionTitles() {
  collectionDetails.forEach(details => {details.open = !phone.matches;});
  titles.forEach((rec,product) => {
   if (!product.isConnected) {titles.delete(product);return;}
   const media = product.querySelector('.product__media-wrapper');
   if (phone.matches && media && rec.title.parentElement !== product) {
    product.insertBefore(rec.title,media);rec.title.classList.add('mbm-v11-product-title');
   } else if (!phone.matches && rec.marker.parentNode) {
    rec.marker.parentNode.insertBefore(rec.title,rec.marker);rec.title.classList.remove('mbm-v11-product-title');
   }
  });
  schedule();
 }
 function initialize(scope = document) {
  scope.querySelectorAll('.mbm-collection-head__description').forEach(description => {
   if (description.closest('.mbm-v11-collection-details')) return;
   const first = description.querySelector('p');
   if (first && first.textContent.trim()) {
    const teaser = document.createElement('p');teaser.className='mbm-v11-collection-teaser';teaser.textContent=first.textContent;description.before(teaser);
   }
   const details=document.createElement('details');details.className='mbm-v11-collection-details';
   const summary=document.createElement('summary');summary.textContent='עוד על הבובות וההתאמה האישית';
   description.before(details);details.append(summary,description);collectionDetails.add(details);
  });
  scope.querySelectorAll('.product').forEach(product => {
   if (titles.has(product)) return;
   const title = product.querySelector('.product__info-container .product__title');
   if (!title || !product.querySelector('.product__media-wrapper')) return;
   const marker = document.createComment('mbm-v11-title-origin');
   title.before(marker);titles.set(product,{title,marker});
  });
  scope.querySelectorAll('[data-mbm-product-info]').forEach(info => {
   if (navigators.has(info)) return;
   const nav = info.querySelector('[data-mbm-tabs]');
   if (!nav) return;
   const anchor = document.createElement('div');
   anchor.className = 'mbm-v11-tabs-anchor';anchor.setAttribute('role','presentation');
   nav.before(anchor);info.classList.add('mbm-v11-ready');
   const rec = {nav,anchor,observer:null};navigators.set(info,rec);
   if ('ResizeObserver' in window) {
    rec.observer = new ResizeObserver(schedule);rec.observer.observe(info);rec.observer.observe(nav);
   }
   const keepContext = event => {
    if (!nav.classList.contains('is-pinned') || !event.target.closest('[data-mbm-tab]')) return;
    if (event.type === 'keydown' && !['ArrowLeft','ArrowRight','Home','End',' '].includes(event.key)) return;
    requestAnimationFrame(() => {
     const y = anchor.getBoundingClientRect().top + window.scrollY - headerOffset() - 2;
     window.scrollTo({top:Math.max(0,y),behavior:reduced.matches?'auto':'smooth'});schedule();
    });
   };
   nav.addEventListener('click',keepContext,true);nav.addEventListener('keydown',keepContext,true);
   info.addEventListener('toggle',schedule,true);
  });
  positionTitles();
 }
 window.addEventListener('scroll',schedule,{passive:true});
 window.addEventListener('resize',schedule,{passive:true});
 window.addEventListener('pageshow',schedule);
 window.visualViewport?.addEventListener('resize',schedule,{passive:true});
 phone.addEventListener('change',positionTitles);
 document.addEventListener('shopify:section:load',event => initialize(event.target));
 document.addEventListener('shopify:section:unload',schedule);
 document.fonts?.ready.then(schedule);
 initialize();
})();
